import * as React from 'react';

import { Location, LocationParams } from 'lib/componentLocation';
import { IRoute } from 'lib/componentRouter';
import TZDate from 'lib/TZDate';
import { TZUtils } from 'lib/TZUtils';
import { tzmoment } from 'lib/tzmoment';

import { AppWrapper } from 'portcall/appwrapper/model';
import { AppWrapperView } from 'portcall/appwrapper/view';
import { NavbarTab } from 'portcall/navbar/view';

import { BerthManagerDashboard, BerthManagerDashboardParams, Tab } from './model';
import { ActivityFeedTab } from './activityfeed';
import { BerthManagerDashboardView } from './view';
import { Column } from './servicesdashboard';

export const BerthManagerDashboardRoute = (model : (params : BerthManagerDashboardParams) => BerthManagerDashboard, appWrapper: AppWrapper, tzutils : TZUtils, loc : Location) : IRoute => {
    const m = model(inboundParams(loc.params, tzutils));
    return {
        view: 
            <AppWrapperView model={appWrapper} navbarTab={NavbarTab.More}>
                <BerthManagerDashboardView model={m} tzutils={tzutils} />
            </AppWrapperView>,
        reflectState: () => outboundParams(loc, m, tzutils)
    };
};

let inboundParams = (p : LocationParams, tzutils : TZUtils) : BerthManagerDashboardParams => ({ 
        id :             +(p["id"] || 0),
        tab:             'tab' in p ? +(p["tab"] || 0) : Tab.Activity,
        activityFeedTab: 'activityFeedTab' in p ? +(p["activityFeedTab"] || 0) : ActivityFeedTab.New,
        date:            p["date"] ? tzutils.setTimezoneOffset(new TZDate(p["date"] + "T00:00:00Z"), true) : tzutils.today(),
        filter:          p["filter"] || '',
        sort:            'sort' in p ? +(p['sort'] || 0) : Column.Time,
        reversed:        !!p['reversed']
    }),
    outboundParams = (loc : Location, m : BerthManagerDashboard, tzutils : TZUtils) => {
        const p = {} as LocationParams;

        p["id"] = m.Id + '';
        if (m.CurrentTab() !== Tab.Activity)                         p["tab"] = m.CurrentTab() + '';
        if (m.ActivityFeed.Tab() !== ActivityFeedTab.New)            p["activityFeedTab"] = m.ActivityFeed.Tab() + '';
        if (!TZDate.eq(m.ServicesDashboard.Date(), tzutils.today())) p["date"] = tzmoment(m.ServicesDashboard.Date()).format("YYYY-MM-DD");
        if (m.ServicesDashboard.Filter())                            p['filter'] = m.ServicesDashboard.Filter();
        if (m.ServicesDashboard.Sort() !== Column.Time)              p['sort'] = m.ServicesDashboard.Sort() + '';
        if (m.ServicesDashboard.SortReversed())                      p['reversed'] = '1';

        return new Location(loc.name, p);
    };



// WEBPACK FOOTER //
// ./apps/portcall/berthmgrdashboard/route.tsx